import React, { useState, useEffect } from 'react';
import { editUser } from '../../routing/routes';
import { useHistory } from 'react-router-dom';

const EditUserFrame = ({ user, refreshData, roles, setNotification, permisos }) => {
	const history = useHistory();
	const [UserParams, setUserParams] = useState({ _id: user._id, rol: user.rol, username: user.username, password: '', cpassword: '' });

	useEffect(() => {
		setUserParams({ _id: user._id, rol: user.rol, username: user.username, password: '', cpassword: '' });
	}, [user]);

	return (
		<div style={{ width: '80%', margin: '40px auto' }}>
			<div align='right'>
				<div className='taby'>Editar Usuario</div>
			</div>
			<div className='form-container'>
				<h3> Nombre del usuario: {UserParams.username} </h3>
				<h3> Seleccione un rol: </h3>
				<select
					style={{ width: '30%' }}
					onChange={(event) => setUserParams({ ...UserParams, rol: event.target.value })}
					value={UserParams.rol}
					disabled={!permisos.modificarUsuarios}
				>
					<option key='' value=''>
						Seleccione...
					</option>
					{roles.map((rol) => (
						<option key={rol} value={rol}>
							{rol}
						</option>
					))}
				</select>

				<h3> Nueva contraseña: </h3>
				<input
					onChange={(event) => setUserParams({ ...UserParams, password: event.target.value })}
					type='password'
					style={{ width: '80%' }}
					value={UserParams.password}
				></input>
				<br />
				<h3> Confirmar nueva contraseña: </h3>
				<input onChange={(event) => setUserParams({ ...UserParams, cpassword: event.target.value })} type='password' style={{ width: '80%' }}></input>
				<br />
				{UserParams.password !== UserParams.cpassword && <span style={{ fontSize: 12, color: 'red' }}>Las contraseñas no coinciden</span>}

				<div className='form-actions' align='right'>
					{/* Boton para cancelar el registro de un usuario */}
					<button className='form-button secondary-button' onClick={() => history.push('/users')}>
						Cancelar
					</button>

					{/* Boton para guardar usuario */}
					<button
						disabled={UserParams.password !== UserParams.cpassword || !UserParams.password || !UserParams.rol} // !Users.every( e => e.username !== UserParams.username) <---- returns true if the user name already exists
						onClick={() => Modify(UserParams, history, refreshData, setNotification)}
						className='form-button primary-button'
					>
						Guardar
					</button>
				</div>
			</div>
		</div>
	);
};

export default EditUserFrame;

function Modify(UserParams, history, refreshData, setNotification) {
	const ModifiedUser = { ...UserParams };
	delete ModifiedUser.cpassword;
	editUser(ModifiedUser)
		.catch((error) => {
			console.error('Error:', error);
			setNotification('eError al modificar el usuario');
			history.push('/users');
		})
		.then(() => {
			refreshData();
			setNotification('mUsuario modificado correctamente');
			history.push('/users');
		});
}
